import { render } from "./DentalTourismPageBigScreen.vue?vue&type=template&id=61a8623e"
import script from "./DentalTourismPageBigScreen.vue?vue&type=script&lang=js"
export * from "./DentalTourismPageBigScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__